
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { Divider } from "@material-ui/core";

export const renderMarkDown = message => (
    <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
            hr: () => (
                <Divider style={{ margin: "12px 0" }} />
            ),
            h1: ({ children }) => (
                <Typography
                    variant="h6"
                    component="h1"
                    gutterBottom
                    style={{ fontWeight: 600, marginTop: 12 }}
                >
                    {children}
                </Typography>
            ),
            h2: ({ children }) => (
                <Typography
                    variant="subtitle1"
                    component="h2"
                    gutterBottom
                    style={{ fontWeight: 600, marginTop: 10 }}
                >
                    {children}
                </Typography>
            ),

            h3: ({ children }) => (
                <Typography
                    variant="body1"
                    component="h3"
                    gutterBottom
                    style={{ fontWeight: 600, marginTop: 8 }}
                >
                    {children}
                </Typography>
            ),
            h4: ({ children }) => (
                <Typography
                    variant="body2"
                    component="h4"
                    gutterBottom
                    style={{ fontWeight: 600, marginTop: 8 }}
                >
                    {children}
                </Typography>
            ),
            h5: ({ children }) => (
                <Typography
                    variant="body2"
                    component="h5"
                    gutterBottom
                    style={{ fontWeight: 600 }}
                >
                    {children}
                </Typography>
            ),
            h6: ({ children }) => (
                <Typography
                    variant="caption"
                    component="h6"
                    gutterBottom
                    style={{ fontWeight: 600 }}
                >
                    {children}
                </Typography>
            ),
            p: ({ children }) => (
                <Typography
                    variant="body2"
                    component="div"
                    style={{ marginBottom: 8 }}
                >
                    {children}
                </Typography>
            ),

            strong: ({ children }) => (
                <strong style={{ fontWeight: 600 }}>{children}</strong>
            ),

            em: ({ children }) => <em>{children}</em>,

            ul: ({ children }) => (
                <ul style={{ margin: "6px 0 6px 18px" }}>
                    {children}
                </ul>
            ),

            ol: ({ children }) => (
                <ol style={{ margin: "6px 0 6px 18px" }}>
                    {children}
                </ol>
            ),

            li: ({ children }) => (
                <li>
                    <Typography variant="body2" component="span">
                        {children}
                    </Typography>
                </li>
            ),

            // Inline code and fenced code content
            code: ({ inline, className, children, ...props }) => (
                <code
                    {...props}
                    className={className}
                    style={
                        inline
                            ? {
                                  backgroundColor: "#f1f3f5",
                                  color: "#c7254e",
                                  padding: "2px 5px",
                                  borderRadius: 4,
                                  fontFamily: "monospace",
                                  fontSize: "0.9em"
                              }
                            : {
                                  color: "#24292f",
                                  fontFamily: "monospace",
                                  fontSize: 13,
                                  lineHeight: 1.6
                              }
                    }
                >
                    {children}
                </code>
            ),

            // Background and layout for the entire code block
            pre: ({ children }) => (
                <pre
                    style={{
                        backgroundColor: "#f6f8fa",
                        color: "#24292f",
                        border: "1px solid #dfe3e8",
                        borderRadius: 8,
                        padding: "12px 14px",
                        margin: "10px 0",
                        overflowX: "auto",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                        fontSize: 13,
                        lineHeight: 1.6,
                        whiteSpace: "pre"
                    }}
                >
                    {children}
                </pre>
            ),

            a: ({ href, children }) => (
                <Link
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {children}
                </Link>
            )
        }}
    >
        {message || ""}
    </ReactMarkdown>
);
